import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import logo from '../../assets/logo.png';
import ThemeToggle from '../ui/ThemeToggle';
import { useConsoleTheme } from '../../lib/theme';

// The centred card the sign-in family of pages share (sign in, set password,
// forgot password). `badge` is the small label above the heading.
export default function AuthShell({ badge, badgeIcon: BadgeIcon, title, subtitle, children, backTo = '/login', backLabel = 'Back to sign in' }) {
  useConsoleTheme(); // marks <html> with the console theme while mounted
  return (
    <div className="portal-skin min-h-screen relative flex flex-col">
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 grain-bg opacity-[0.13]" />
      </div>
      <div className="relative z-[1] flex-1 flex flex-col px-6 md:px-8 pt-10 pb-16">
        {backTo && (
          <Link to={backTo} className="group inline-flex items-center gap-2 text-sm text-gray-500 hover:text-white transition-colors self-start">
            <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-0.5" />
            {backLabel}
          </Link>
        )}
        {/* Level with the back link, top right; absolute so nothing else moves.
            z-10: without a back link a tall card (the invite form on a phone)
            starts at the top and would otherwise paint over the switch. */}
        <div className="absolute top-[34px] right-6 md:right-8 z-10">
          <ThemeToggle />
        </div>
        <div className="flex-1 flex items-center justify-center">
          <main className="w-full max-w-md p-8 md:p-10 rounded-2xl bg-white/[0.025] backdrop-blur-sm border border-white/[0.06] shadow-[0_2px_20px_-4px_rgba(0,0,0,0.3)]">
            <div className="flex flex-col items-center text-center mb-8">
              <img src={logo} alt="NexSav Innovate" data-light-invert className="h-10 w-auto mb-6 opacity-90" />
              {badge && (
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/[0.04] border border-white/[0.08] mb-5">
                  {BadgeIcon && <BadgeIcon className="w-3 h-3 text-[#B0FC38]" aria-hidden="true" />}
                  <span className="text-[10px] font-medium text-[#B0FC38] tracking-wider uppercase">{badge}</span>
                </div>
              )}
              <h1 className="text-2xl font-semibold text-white tracking-tight text-balance">{title}</h1>
              {subtitle && <p className="text-sm text-gray-400 mt-2">{subtitle}</p>}
            </div>
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}

export const authInputCls =
  'w-full px-5 py-3.5 pl-11 rounded-xl bg-white/[0.04] border border-white/[0.06] text-white text-sm placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-[#B0FC38]/30 focus:border-[#B0FC38]/30 focus:bg-white/[0.06] transition-all';

export const authButtonCls =
  'inline-flex items-center justify-center gap-2 w-full px-6 py-3.5 rounded-full bg-[#B0FC38] text-gray-900 text-sm font-semibold hover:bg-[#9BE22E] shadow-lg shadow-[#B0FC38]/25 transition-all disabled:opacity-60 disabled:cursor-not-allowed';
